import { SxProps, Theme } from '@mui/material/styles';

export const titleSideBarSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontWeight: '800',
	fontSize: 'var(--font-size-body)',
	textTransform: 'uppercase',
};

export const bodySideBarSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontWeight: 'normal',
	fontSize: 'var(--font-size-default)',
};
